import type { Inventory } from '@libs/common-node';
import { logger } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export async function getProductInventory(sku: string, stores: string[]) {
    const url = CWEA_ENDPOINTS.inventory.getProductInventory(sku);
    return await cweaClient.post<Inventory, { stores: string[] }>(url, {
        body: { stores },
        useOldFetch: true,
    });
}

type StoreSkuPair = { store: string; sku: string };

export async function getProductInventoryPairs(storesku?: StoreSkuPair[]) {
    if (!Array.isArray(storesku) || storesku.length === 0) {
        logger.warn(`[getProductInventoryPairs] storesku is undefined or empty.\n`);
        return [];
    }

    const filteredStoresku = storesku.filter(({ store, sku }) => Boolean(store?.trim() && sku?.trim()));

    if (filteredStoresku.length === 0) {
        logger.warn(`[getProductInventoryPairs] filteredStoresku or empty after filter invalid sku-store.\n`);
        return [];
    }

    const url = CWEA_ENDPOINTS.inventory.getProductInventoryPairs;
    try {
        return (
            (await cweaClient.post<Inventory[], { storesku: StoreSkuPair[] }>(url, {
                body: { storesku: filteredStoresku },
                useOldFetch: true,
            })) ?? []
        );
    } catch (error) {
        logger.error(`[getProductInventoryPairs] Error fetching product inventory pairs:\n ${error}`);
        return [];
    }
}
